import React, { useEffect, useState } from "react";
import { MessageCircle, Phone, ArrowUp } from "lucide-react";

const PHONE = "+971555752118";
const WA = "971555752118";
const WA_MSG = encodeURIComponent(
  "Hi One Sphere, I'd like to enquire about your trading services."
);

/**
 * FloatingCTA — sticky conversion stack.
 * Bottom-right: WhatsApp + Call + scroll-to-top (after scroll)
 * Hidden until user has scrolled past hero.
 */
export default function FloatingCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="floating-cta"
      className={`fixed z-40 right-4 sm:right-6 bottom-4 sm:bottom-6 flex flex-col items-end gap-3 transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      {/* WhatsApp */}
      <a
        href={`https://wa.me/${WA}?text=${WA_MSG}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="WhatsApp One Sphere"
        className="group relative inline-flex items-center gap-2 bg-[#25D366] text-white pl-4 pr-5 py-3 rounded-full shadow-[0_10px_30px_-10px_rgba(37,211,102,0.6)] hover:shadow-[0_14px_40px_-12px_rgba(37,211,102,0.7)] hover:-translate-y-0.5 transition-all duration-300"
      >
        <MessageCircle className="w-4 h-4" strokeWidth={2} />
        <span className="text-sm font-medium tracking-wide">WhatsApp</span>
        <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-white border border-[#25D366] animate-pulse" />
      </a>

      {/* Call */}
      <a
        href={`tel:${PHONE}`}
        data-testid="floating-call"
        aria-label="Call One Sphere"
        className="inline-flex items-center gap-2 bg-primary text-primary-foreground pl-4 pr-5 py-3 rounded-full shadow-[0_10px_30px_-10px_rgba(30,58,138,0.5)] hover:bg-foreground hover:-translate-y-0.5 transition-all duration-300"
      >
        <Phone className="w-4 h-4" strokeWidth={2} />
        <span className="text-sm font-medium tracking-wide">Call</span>
      </a>

      {/* Scroll top — small */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        data-testid="floating-scroll-top"
        aria-label="Scroll to top"
        className="hidden sm:inline-flex w-10 h-10 items-center justify-center rounded-full bg-card border border-border text-foreground/70 hover:text-primary hover:border-primary transition-all duration-300"
      >
        <ArrowUp className="w-4 h-4" />
      </button>
    </div>
  );
}
